<template>
  <v-snackbar
    v-model="snackbarOpen"
    :timeout="3000"
    :color="color"
    bottom
    right
    auto-height
    multi-line
  >
    <v-container>
      <div class="snackbar-content">
        <v-btn flat icon color="white" @click="snackbarOpen = false">
          <v-icon>close</v-icon>
        </v-btn>
        <v-layout column>
          <v-flex>
            <v-layout align-center>
              <v-flex class="flex-shrink">
                <v-icon class="mr-2" color="white" large>
                  {{ icon }}
                </v-icon>
              </v-flex>
              <v-flex class="flex-grow">
                <span class="snackbar-title text--white">{{ title }}</span>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex>
            {{ message }}
          </v-flex>
        </v-layout>
      </div>
    </v-container>
  </v-snackbar>
</template>

<script>
export default {
  name: 'success-snackbar',
  props: {
    open: Boolean,
    title: String,
    message: String,
    type: {
      type: String,
      default: 'success',
    },
  },
  data() {
    return {
      snackbarOpen: this.open,
    }
  },
  computed: {
    color() {
      switch (this.type) {
      case 'success':
        return 'primary'
      case 'warning':
        return 'warning'
      case 'error':
        return 'error'
      default:
        return 'primary'
      }
    },
    icon() {
      switch (this.type) {
      case 'success':
        return 'check'
      case 'warning':
        return 'warning'
      case 'error':
        return 'error'
      default:
        return 'primary'
      }
    },
  },
  watch: {
    open(value) {
      this.snackbarOpen = value
    },
    snackbarOpen(current, prev) {
      if (prev !== current) {
        this.$emit('update:open', current)
      }
    },
  },
}
</script>

<style scoped>
.snackbar-content {
  position: relative; /* Allow positioning of child elements */
}

.v-btn {
  position: absolute; /* Position the button absolutely */
  top: 0; /* Adjust as needed */
  right: 0; /* Adjust as needed */
}
</style>
